import { InjectionToken } from '@angular/core';

export const LAUNCH_DARKLY_CLIENT_ID = new InjectionToken<string>('LaunchDarkly.ClientId');
